export default __webpack_public_path__ + "static/media/mobileFader5.979fac1c.png";